import { Component, OnInit } from '@angular/core';
import { ProductRamService } from '../../../services/product-ram.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-rams',
  templateUrl: './list-product-rams.component.html',
  styleUrls: ['./list-product-rams.component.css'],
  providers:[ProductRamService,ProductService]
})
export class ListProductRamsComponent implements OnInit {

  productRams:any = [];

  constructor(private productRamService:ProductRamService, private productService:ProductService) { }

  ngOnInit() {
    this.getProductRams();
  }

  getProductRams(){
    this.productRamService.query({})
      .subscribe((productRams) => {
        this.productRams = productRams;
        this.parseProducts();
      });
  }

  parseProducts(){
    this.productRams.forEach(function (productRam){
      productRam.productTypes = "";
      if(productRam.product_types.includes("1")){
        productRam.productTypes += "Móviles y Tablets,";
      }
      if(productRam.product_types.includes("2")){
        productRam.productTypes += "Consolas,";
      }
      if(productRam.product_types.includes("3")){
        productRam.productTypes += "Artículos Varios,";
      }
      if(productRam.product_types.includes("4")){
        productRam.productTypes += "PC's-portátiles,";
      }
      productRam.productTypes = productRam.productTypes.substring(0,productRam.productTypes.length - 1);
    });
  }


  delete(productRam){
    this.productService.query({so:productRam.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productRamService.delete(productRam.id)
        .subscribe((productOperatingSystem) => {
          this.getProductRams()
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-rams/list-product-rams/list-product-rams.component.ts